module.exports = __webpack_public_path__ + "static/media/DTH.375715fb.svg";